const generateTimeOptions = () => {
  const times = [];
  const minutes = ['00', '30'];
  for (let i = 0; i < 48; i += 1) {
    times.push(i);
  }
  return times.map(time => {
    const h = Math.floor(time / 2);
    if (time === 0) {
      return {
        label: 'Midnight',
        value: `${h.toString().padStart(2, '0')}:00`
      };
    }
    if (time === 24) {
      return {
        label: 'Noon',
        value: `${h.toString().padStart(2, '0')}:00`
      };
    }
    const hour = h === 0 || h === 12 ? 12 : h % 12;
    const minute = minutes[time % 2];
    const meridiem = h < 12 ? 'AM' : 'PM';
    const value = `${h.toString().padStart(2, '0')}:${minute}`;
    return {
      key: value,
      label: `${hour}:${minute} ${meridiem}`,
      value
    };
  });
};
export default generateTimeOptions;